import { render, staticRenderFns } from "./HelpImage.vue?vue&type=template&id=2a2035fb&"
import script from "./HelpImage.vue?vue&type=script&lang=ts&"
export * from "./HelpImage.vue?vue&type=script&lang=ts&"
import style0 from "./HelpImage.vue?vue&type=style&index=0&id=2a2035fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports